import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SummaryStatCard from '../common/SummaryStatCard';

const MoneyMovementsPanel = ({ summary, currency }) => {
  const { t } = useTranslation();
  if (!summary) {
    return null;
  }

  return (
    <Stack id="money-movements-panel" spacing={2} sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="body2" color="text.secondary">{t('expenses.money.help')}</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <SummaryStatCard
          label={t('expenses.money.in')}
          value={summary.cashIn}
          currencyCode={currency}
          formattedValue={summary.cashIn == null ? t('expenses.money.unavailable') : undefined}
        />
        <SummaryStatCard label={t('expenses.money.out')} value={summary.postedTotal} currencyCode={currency} />
        <SummaryStatCard
          label={t('expenses.money.net')}
          value={summary.net}
          currencyCode={currency}
          emphasizeNegative
          formattedValue={summary.net == null ? t('expenses.money.unavailable') : undefined}
        />
        <SummaryStatCard label={t('expenses.money.scheduled')} value={summary.scheduledTotal} currencyCode={currency} />
      </Stack>
    </Stack>
  );
};

export default MoneyMovementsPanel;
